module.exports = __webpack_public_path__ + "img/search-external.7affd31b.svg";